'use strict';

module.exports = {
  DEFAULT_HANDLE_KEY: ''
};